export const appLayoutTemplateAttributeName = 'data-app-layout-template';
export const appLayoutRegionAttributeName = 'data-app-layout-region';

export type AppLayoutTemplate = 'multi-column' | 'single-column';
export const appLayoutTemplates: readonly AppLayoutTemplate[] = ['multi-column', 'single-column'];

export type AppLayoutRegion =
  | 'app-header'
  | 'app-banner'
  | 'app-subheader'
  | 'outer-left-nav'
  | 'left-nav'
  | 'back-button-row'
  | 'app-main-area'
  | 'content-header'
  | 'main-content'
  | 'content-sidebar-left'
  | 'content-sidebar-right'
  | 'content-sidebar-panel'
  | 'app-footer'
  | 'media-content'
  | 'media-sidebar';
export const appLayoutRegions: readonly AppLayoutRegion[] = [
  'app-header',
  'app-banner',
  'app-subheader',
  'outer-left-nav',
  'left-nav',
  'back-button-row',
  'app-main-area',
  'content-header',
  'main-content',
  'content-sidebar-left',
  'content-sidebar-right',
  'content-sidebar-panel',
  'app-footer',
  'media-content',
  'media-sidebar',
];
